import { Component, computed, input } from '@angular/core';

export type NotificationSeverity = 'info' | 'success' | 'warning' | 'error';

@Component({
  selector: 'app-notification',
  imports: [],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
})
export class NotificationComponent {
  message = input.required<string>();
  severity = input<NotificationSeverity>('info');

  alertClass = computed(() => `swd-alert swd-alert--${this.severity()}`);

  iconClass = computed(() => {
    const icons: Record<NotificationSeverity, string> = {
      info: 'pi pi-info-circle',
      success: 'pi pi-check-circle',
      warning: 'pi pi-exclamation-triangle',
      error: 'pi pi-times-circle',
    };
    return icons[this.severity()];
  });
}
